import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../../shared/shared.module';
import { NotificationPreferencesDashboardPage } from './notification-preferences-dashboard.page';
import { AlertPanelComponent } from './components/alert-panel/alert-panel.component';
import { NotificationPreferencesDashboardPageRoutingModule } from './notification-preferences-dashboard-routing.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NotificationPreferencesDashboardPageRoutingModule,
    SharedModule,
  ],
  declarations: [AlertPanelComponent, NotificationPreferencesDashboardPage],
})
export class NotificationPreferencesDashboardPageModule {}
